import { shaking } from '@/utils/animation'

export default {
  data() {
    return {
      isLoading: false
    }
  },
  methods: {
    onSubmit() {
      this.$v.$touch()
      if (this.$v.$valid) {
        this.isLoading = true

        this.submit()
          .catch(e => {
            this.$buefy.toast.open({
              message: e.response.data,
              type: 'is-danger',
              queue: false
            })
          })
          .finally(() => { this.isLoading = false })
      } else {
        shaking(this.$refs.submit)
      }
    }
  }
}
